import { capitalCase } from "change-case";
import { DailyFormIssueStatus } from "generated/graphql";

export const workOrderStatusOptions = Object.values(DailyFormIssueStatus).map((value) => ({
  value,
  label: capitalCase(value.toLowerCase().replace(/_/g, " ")),
}));

export type WorkOrderStatusValue = (typeof workOrderStatusOptions)[number]["value"];

export const activeWorkOrderStatuses = workOrderStatusOptions
  .map((option) => option.value)
  .filter((status) => status !== "DONE");
